import type { OrderLocation } from "./InfoPopup";

export function orderPinColor(orders: Pick<OrderLocation, "createdAt">[], now = Date.now()): string {
  const maxDays = orders.reduce((oldest, order) => {
    const created = order.createdAt instanceof Date ? order.createdAt.getTime() : new Date(order.createdAt || "").getTime();
    const days = Math.floor((now - created) / 86400000);
    return Number.isFinite(days) ? Math.max(oldest, days) : oldest;
  }, 0);
  return maxDays <= 3 ? "#2e7d32" : maxDays <= 7 ? "#ff9800" : "#d32f2f";
}

export function orderPinIcon(color: string): google.maps.Icon | string {
  const svg = `
    <svg width="36" height="36" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2c-3.866 0-7 3.134-7 7 0 5.25 7 13 7 13s7-7.75 7-13c0-3.866-3.134-7-7-7z"
            fill="${color}" stroke="white" stroke-width="1.5"/>
      <circle cx="12" cy="9" r="2.5" fill="white"/>
    </svg>
  `;
  const url = "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg);
  return window.google?.maps ? {
    url, scaledSize: new google.maps.Size(36, 36), anchor: new google.maps.Point(18, 33),
    labelOrigin: new google.maps.Point(18, 13.5),
  } : url;
}
